// extracted by mini-css-extract-plugin
module.exports = {"event":"ChartMaterialModal_event__3vy2w"};